import PluginAction from '../../plugin-action';

/**
 * Action for showing an overview of vendor offers.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class VendorAction extends PluginAction {
    constructor(container: HTMLElement) {
        super(container);

        // Hide supported club collapse button on click. A separate submit button is used to actually send the form.
        const clubFormCollapseButton = container.querySelector('#clubFormCollapseButton');
        if (clubFormCollapseButton) {
            clubFormCollapseButton.addEventListener('click', () => {
                clubFormCollapseButton.classList.add('d-none');
            });
        }

        VendorAction.emitter.emit('ready', this);
    }
}
